import { extend } from 'sk-ui/lib/utils/util.js'

import { action } from 'sky-engine/api'

import collectPeripheralDetailForm from './metaData/collectPeripheralDetailForm'
import compatible from './metaData/compatible'
import peripheral from './metaData/peripheral'
import peripheralDetailForm from './metaData/peripheralDetailForm'
import peripheralForm from './metaData/peripheralForm'
import relateTestCase from './metaData/relateTestCase'

import { PROJECT_COLLECT_REPORT } from '@/api'

export default {
  PeripheralCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: peripheralForm,
      props
    })
  },
  PeripheralCompatibleProductRelationByName({ commit }, params) {
    const props = {
      params: {
        name: params.peripheralName
      }
    }
    const compatibleCopy = extend(true, {}, compatible)
    this.dispatch('OpenDetailDialog', { metaData: compatibleCopy, props, clone: false })
  },
  PeripheralCompatibleProductRelationById({ commit }, params) {
    const props = {
      params: {
        peripheralId: params.peripheralId
      }
    }
    const compatibleCopy = extend(true, {}, compatible)
    this.dispatch('OpenDetailDialog', { metaData: compatibleCopy, props, clone: false })
  },
  CompatibleProductRelation({ commit }, params) {
    const props = {
      params: {
        peripheralId: params.row.id
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: compatible,
      props
    })
  },
  RelationSelectPeripheral({ commit }, props) {
    const peripheralCopy = extend(true, {}, peripheral)

    peripheralCopy.view.formItemId = props.formItemId
    this.dispatch('OpenRelationDialog', {
      metaData: peripheralCopy,
      props,
      clone: false
    })
  },
  PeripheralEdit({ commit }, params) {
    const props = {
      title: '编辑外设',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, peripheralForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  peripheralRelateTestCase({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        peripheralId: params.rowIds[0]
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: relateTestCase,
      props
    })
  },
  ShowPeripheralRelationDetail({ commit }, params) {
    var props = {
      params: {
        id: params.peripheralId
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: peripheralDetailForm,
      props,
      drawerProps: {
        title: '【' + params.name + '】详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  ShowPeripheralDetail({ commit }, params) {
    var props = {
      params: {
        id: params.id
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: peripheralDetailForm,
      props,
      drawerProps: {
        title: '【' + params.name + '】详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  ShowCollectPeripheralDetail({ commit }, params) {
    var props = {
      params: {
        id: params.id
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: collectPeripheralDetailForm,
      props,
      drawerProps: {
        title: '【' + params.name + '】详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  featureRelationTeatCase({ commit }, params) {
    import('../casePeripheralMng/metaData/casePeripheral').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      var props = {
        params: params
      }
      metaDataCopy.default.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  },
  peripheralRelationTestCase({ commit }, props) {
    import('../casePeripheralMng/metaData/casePeripheral').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      metaDataCopy.default.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  },
  syncYunZhiPeripheral({ commit }, props) {
    const req = {
      model: 'Peripheral'
    }
    action(PROJECT_COLLECT_REPORT, 'syncCompatFromYunZhi', req)
      .then(response => {
        this.dispatch('OpenNotification', { message: '外设兼容性同步成功', type: 'success' })
      })
      .catch(e => {
        throw e
      })
  }
}
